<template>
  <div>
    <div class="wrapper gideWebLayout">
      <GideHeader />
      <div id="content-page" class="content-page container" :style="getLayoutStyles()">
        <div class="p-30px mt-2">
          <router-view/>
        </div>
      </div>
      <GideFooter />
    </div>
  </div>
</template>
<script>
import { socialvue } from "../config/pluginInit"
import GideHeader from "../views/Public/GideHeader.vue"
import GideFooter from "../views/Public/GideFooter.vue"
export default {
  name: "ContentLayout",
  components: {
    GideHeader,
    GideFooter
  },
  computed: {
    currentRouteName () {
      return this.$route.name
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    socialvue.mainIndex()
  },
  methods: {
    /**
     * getLayoutStyles
     */
    getLayoutStyles () {
      if (this.currentRouteName.includes("GideEvent")) {
        return `padding: 35px 15px 0!important;`
      }
      else {
        return ""
      }
    }
  }
}
</script>
<style>
  @import url("../assets/css/custom.css");
  .container{
    max-width: 1200px !important;
  }
</style>
